var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01562 15.2781L4.19562 14.0213C4.57363 13.6194 4.78162 13.0856 4.78162 12.5178V7.54483C4.78162 6.10195 5.37162 4.72286 6.40162 3.76377C7.43962 2.79618 8.76163 2.37086 10.1386 2.56332C12.4656 2.89187 14.2206 5.12904 14.2206 7.76813V12.5178C14.2206 13.0856 14.4286 13.6194 14.8056 14.0203L15.9866 15.2781H3.01562ZM11.5 17.7678C11.5 18.7237 10.584 19.5318 9.5 19.5318C8.416 19.5318 7.5 18.7237 7.5 17.7678V17.4052H11.5V17.7678ZM18.0213 14.4363L16.2203 12.5181V7.76839C16.2203 4.06707 13.7183 0.922921 10.4003 0.456136C8.47834 0.183934 6.53834 0.808086 5.08334 2.16485C3.61934 3.52798 2.78134 5.48869 2.78134 7.5451L2.78034 12.5181L0.979335 14.4363C0.510335 14.936 0.371335 15.6793 0.625335 16.3311C0.880335 16.9839 1.47334 17.405 2.13734 17.405H5.50034V17.7676C5.50034 19.9133 7.29434 21.6582 9.50034 21.6582C11.7063 21.6582 13.5003 19.9133 13.5003 17.7676V17.405H16.8633C17.5273 17.405 18.1193 16.9839 18.3733 16.3321C18.6283 15.6793 18.4903 14.935 18.0213 14.4363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.76a219912aeea04cf1d735dc52f8bc8f.svg";
export { ForwardRef as ReactComponent };